import { LanguagePreference } from 'constants/loanApplication';
import { getConditionalObject } from 'utils/data';

export const normalizeForm = ({ form, entityId }) => {
  const { languagePreference, otherLanguagePreference } =
    form[entityId]?.declarations?.languagePreference ?? {};

  const isOtherLanguageSelected = languagePreference?.value === LanguagePreference.OTHER;

  return {
    ...form,
    [entityId]: {
      ...form[entityId],
      declarations: {
        ...form[entityId]?.declarations,
        languagePreference: {
          languagePreference,

          ...getConditionalObject(isOtherLanguageSelected, {
            otherLanguagePreference,
          }),
        },
      },
    },
  };
};
